import { useState } from 'react';
import { Button } from '@sharpe/ui/catalyst';
import { authClient } from '@/lib/auth-client';

type LoginButtonProps = {
  providerId: string;
  providerName: string;
  iconPath?: string;
};

export function LoginButton({ providerId, providerName, iconPath }: LoginButtonProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleSignIn = async () => {
    setIsLoading(true);
    try {
      await authClient.signIn.social({
        provider: providerId as 'okta',
        callbackURL: '/',
      });
    } catch (error) {
      console.error('Sign in error:', error);
      setIsLoading(false);
    }
  };

  return (
    <Button color="primary" onClick={handleSignIn} loading={isLoading} className="w-full">
      {!isLoading && iconPath ? (
        <img
          src={iconPath}
          alt={providerName}
          width={14}
          height={14}
          className="invert"
          data-slot="icon"
        />
      ) : null}
      {isLoading ? 'Signing in...' : `Continue with ${providerName}`}
    </Button>
  );
}
